import { ThemeUIStyleObject } from 'theme-ui'

export const styles: Record<string, ThemeUIStyleObject> = {
  poolInfoContainer: {
    width: '100%',
    background: 'white3',
    marginTop: '10px',
    flexDirection: 'column',
    borderRadius: '10px',
    padding: '10px',
  },
}
